import { MobileOS } from '@/common/utils/getMobileOS'

export type InstallAvailabilityReason =
    | 'ready'
    | 'ios-manual-install'
    | 'already-installed'
    | 'prompt-unavailable'
    | 'unsupported-os'

export type InstallAvailabilityInput = {
    os: MobileOS
    isInstalled: boolean
    hasAndroidInstallPrompt: boolean
}

export type InstallAvailability = {
    available: boolean
    reason: InstallAvailabilityReason
}

export function deriveInstallAvailability(input: InstallAvailabilityInput): InstallAvailability {
    if (input.isInstalled) return { available: false, reason: 'already-installed' }
    if (input.os === 'ios') return { available: true, reason: 'ios-manual-install' }
    if (input.os === 'android') {
        if (input.hasAndroidInstallPrompt) return { available: true, reason: 'ready' }
        return { available: false, reason: 'prompt-unavailable' }
    }
    return { available: false, reason: 'unsupported-os' }
}
